export enum ChecklistAnswerCodesEnum {
  TYPE_I = 'TYPE_I',
  TYPE_II = 'TYPE_II',
  TYPE_OTHER = 'TYPE_OTHER',
}
